import { render, staticRenderFns } from "./img2.vue?vue&type=template&id=bdd75630&"
import script from "./img2.vue?vue&type=script&lang=js&"
export * from "./img2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports